import React from 'react'
import { IIdentityInformationExtended } from '../../interfaces/Identity'

const IdentityInformation = (props: IIdentityInformationExtended) => {
  const { title, value, personneInfo, register } = props
  return (
    <div className="row ml0">
      <div className="col5 colMd2 mr3">
        <strong className="fontWeightBold textNoWrap"> {title} :</strong>
      </div>
      <div className="col5 colMd pr0">
        <span className="textPrimaryDark">
          {value
            .filter((n: string) => n)
            .join(', ')
            .trim()}
          {React.Children.toArray(Object.keys(personneInfo).map((pi: string) =>
                personneInfo[pi] &&
                personneInfo[pi].length > 0 && (
                  <input
                    type="hidden"
                    name={pi}
                    value={personneInfo[pi]}
                    ref={register}
              />)
            ))
          }
        </span>
      </div>
    </div>
  )
}

export default IdentityInformation
